import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { FooterState } from './footer.state';
import { Observable } from 'rxjs';
import { Footer } from '../../services/footer/models/footer.model';
import { GetFooter } from './footer.actions';

@Injectable({
  providedIn: 'root'
})
export class FooterFacade {
  private readonly store = inject(Store);

  @Select(FooterState.footer) footer$: Observable<Footer | null>;

  get footer(): Footer {
    return this.store.selectSnapshot(FooterState.footer);
  }

  getFooter(locale: string) {
    return this.store.dispatch(new GetFooter(locale));
  }
}
